/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { BusinessType } from '../models/business-type';
import { CharterContractReportChargeTypes } from '../models/charter-contract-report-charge-types';
import { CharterContractReportDateTypes } from '../models/charter-contract-report-date-types';
import { GenericResponse } from '../models/generic-response';

/**
 * Report APIs
 */
@Injectable({ providedIn: 'root' })
export class ReportService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `downloadVatReport()` */
  static readonly DownloadVatReportPath = '/api/v1/vat-reports/report';

  /**
   * to download VAT details report.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `downloadVatReport()` instead.
   *
   * This method doesn't expect any request body.
   */
  downloadVatReport$Response(
    params?: {
      /**
       * this adds a string search to the following fields:
       *   - from date
       */
      from?: string;

      /**
       * this adds a string search to the following fields:
       *   - to date
       */
      to?: string;

      /**
       * this adds a string search to the following fields:
       *   - client
       */
      clientId?: number;

      /**
       * This allows filtering for reports by  business type
       */
      businessType?: Array<BusinessType>;

      /**
       * This adds a filtering for reports by invoice type
       */
      invoiceType?: string;

      /**
       * This adds a filtering for reports by date type
       */
      dateType?: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<GenericResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      ReportService.DownloadVatReportPath,
      'get'
    );
    if (params) {
      rb.query('from', params.from, {});
      rb.query('to', params.to, {});
      rb.query('clientId', params.clientId, {});
      rb.query('businessType', params.businessType, {});
      rb.query('invoiceType', params.invoiceType, {});
      rb.query('dateType', params.dateType, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<GenericResponse>;
        })
      );
  }

  /**
   * to download VAT details report.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `downloadVatReport$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  downloadVatReport(
    params?: {
      /**
       * this adds a string search to the following fields:
       *   - from date
       */
      from?: string;

      /**
       * this adds a string search to the following fields:
       *   - to date
       */
      to?: string;

      /**
       * this adds a string search to the following fields:
       *   - client
       */
      clientId?: number;

      /**
       * This allows filtering for reports by  business type
       */
      businessType?: Array<BusinessType>;

      /**
       * This adds a filtering for reports by invoice type
       */
      invoiceType?: string;

      /**
       * This adds a filtering for reports by date type
       */
      dateType?: string;
    },
    context?: HttpContext
  ): Observable<GenericResponse> {
    return this.downloadVatReport$Response(params, context).pipe(
      map((r: StrictHttpResponse<GenericResponse>): GenericResponse => r.body)
    );
  }

  /** Path part for operation `downloadGhSalesInvoiceReport()` */
  static readonly DownloadGhSalesInvoiceReportPath =
    '/api/v1/gh-sales-invoice-reports/report';

  /**
   * to download gh sales invoice details report.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `downloadGhSalesInvoiceReport()` instead.
   *
   * This method doesn't expect any request body.
   */
  downloadGhSalesInvoiceReport$Response(
    params?: {
      /**
       * this adds a string search to the following fields:
       *   - from date
       */
      from?: string;

      /**
       * this adds a string search to the following fields:
       *   - to date
       */
      to?: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<GenericResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      ReportService.DownloadGhSalesInvoiceReportPath,
      'get'
    );
    if (params) {
      rb.query('from', params.from, {});
      rb.query('to', params.to, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<GenericResponse>;
        })
      );
  }

  /**
   * to download gh sales invoice details report.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `downloadGhSalesInvoiceReport$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  downloadGhSalesInvoiceReport(
    params?: {
      /**
       * this adds a string search to the following fields:
       *   - from date
       */
      from?: string;

      /**
       * this adds a string search to the following fields:
       *   - to date
       */
      to?: string;
    },
    context?: HttpContext
  ): Observable<GenericResponse> {
    return this.downloadGhSalesInvoiceReport$Response(params, context).pipe(
      map((r: StrictHttpResponse<GenericResponse>): GenericResponse => r.body)
    );
  }

  /** Path part for operation `downloadGhSalesWorkOrderReport()` */
  static readonly DownloadGhSalesWorkOrderReportPath =
    '/api/v1/gh-sales-work-order-reports/report';

  /**
   * to download gh sales work order details report.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `downloadGhSalesWorkOrderReport()` instead.
   *
   * This method doesn't expect any request body.
   */
  downloadGhSalesWorkOrderReport$Response(
    params?: {
      /**
       * this adds a string search to the following fields:
       *   - from date
       */
      from?: string;

      /**
       * this adds a string search to the following fields:
       *   - to date
       */
      to?: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<GenericResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      ReportService.DownloadGhSalesWorkOrderReportPath,
      'get'
    );
    if (params) {
      rb.query('from', params.from, {});
      rb.query('to', params.to, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<GenericResponse>;
        })
      );
  }

  /**
   * to download gh sales work order details report.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `downloadGhSalesWorkOrderReport$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  downloadGhSalesWorkOrderReport(
    params?: {
      /**
       * this adds a string search to the following fields:
       *   - from date
       */
      from?: string;

      /**
       * this adds a string search to the following fields:
       *   - to date
       */
      to?: string;
    },
    context?: HttpContext
  ): Observable<GenericResponse> {
    return this.downloadGhSalesWorkOrderReport$Response(params, context).pipe(
      map((r: StrictHttpResponse<GenericResponse>): GenericResponse => r.body)
    );
  }

  /** Path part for operation `downloadLegWiseReport()` */
  static readonly DownloadLegWiseReportPath = '/api/v1/leg-wise-reports/report';

  /**
   * to download leg wise report.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `downloadLegWiseReport()` instead.
   *
   * This method doesn't expect any request body.
   */
  downloadLegWiseReport$Response(
    params?: {
      /**
       * this adds a string search to the following fields:
       *   - from date
       */
      from?: string;

      /**
       * this adds a string search to the following fields:
       *   - to date
       */
      to?: string;

      /**
       * this adds a string search to the following fields:
       *   - client
       */
      clientId?: number;

      /**
       * This adds a filtering for reports by invoice type
       */
      invoiceType?: string;

      /**
       * This adds a filtering for reports by date type
       */
      dateType?: string;

      /**
       * This enables filtering of leg wise report based on the aircraft id
       */
      aircraftId?: number;

      /**
       * This allows filtering invoices by their business type
       */
      businessType?: Array<BusinessType>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<GenericResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      ReportService.DownloadLegWiseReportPath,
      'get'
    );
    if (params) {
      rb.query('from', params.from, {});
      rb.query('to', params.to, {});
      rb.query('clientId', params.clientId, {});
      rb.query('invoiceType', params.invoiceType, {});
      rb.query('dateType', params.dateType, {});
      rb.query('aircraftId', params.aircraftId, {});
      rb.query('businessType', params.businessType, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<GenericResponse>;
        })
      );
  }

  /**
   * to download leg wise report.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `downloadLegWiseReport$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  downloadLegWiseReport(
    params?: {
      /**
       * this adds a string search to the following fields:
       *   - from date
       */
      from?: string;

      /**
       * this adds a string search to the following fields:
       *   - to date
       */
      to?: string;

      /**
       * this adds a string search to the following fields:
       *   - client
       */
      clientId?: number;

      /**
       * This adds a filtering for reports by invoice type
       */
      invoiceType?: string;

      /**
       * This adds a filtering for reports by date type
       */
      dateType?: string;

      /**
       * This enables filtering of leg wise report based on the aircraft id
       */
      aircraftId?: number;

      /**
       * This allows filtering invoices by their business type
       */
      businessType?: Array<BusinessType>;
    },
    context?: HttpContext
  ): Observable<GenericResponse> {
    return this.downloadLegWiseReport$Response(params, context).pipe(
      map((r: StrictHttpResponse<GenericResponse>): GenericResponse => r.body)
    );
  }

  /** Path part for operation `downloadCharterContractReport()` */
  static readonly DownloadCharterContractReportPath =
    '/api/v1/charter-contract-reports/report';

  /**
   * to generate charter contract report.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `downloadCharterContractReport()` instead.
   *
   * This method doesn't expect any request body.
   */
  downloadCharterContractReport$Response(
    params: {
      /**
       * this adds a string search to the following fields:
       *   - from date
       */
      from: string;

      /**
       * this adds a string search to the following fields:
       *   - to date
       */
      to: string;

      /**
       * optional repeatable client filter for charter contract reports
       */
      clientId?: Array<number>;

      /**
       * which charter date the from/to range applies to. omit for departure
       */
      dateType?: CharterContractReportDateTypes;

      /**
       * optional repeatable aircraft filter for charter contract reports (leg aircraft)
       */
      aircraftId?: Array<number>;

      /**
       * optional repeatable flight type filter for charter contract reports (contract header, exact match)
       */
      flightType?: Array<string>;

      /**
       * which ancillary charges to include. CATERING, INTERNET, LAYOVER_WAITING, FLIGHT, or ALL
       */
      chargeType: CharterContractReportChargeTypes;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<GenericResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      ReportService.DownloadCharterContractReportPath,
      'get'
    );
    if (params) {
      rb.query('from', params.from, {});
      rb.query('to', params.to, {});
      rb.query('clientId', params.clientId, { style: 'form', explode: true });
      rb.query('dateType', params.dateType, {});
      rb.query('aircraftId', params.aircraftId, {
        style: 'form',
        explode: true,
      });
      rb.query('flightType', params.flightType, {
        style: 'form',
        explode: true,
      });
      rb.query('chargeType', params.chargeType, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<GenericResponse>;
        })
      );
  }

  /**
   * to generate charter contract report.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `downloadCharterContractReport$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  downloadCharterContractReport(
    params: {
      /**
       * this adds a string search to the following fields:
       *   - from date
       */
      from: string;

      /**
       * this adds a string search to the following fields:
       *   - to date
       */
      to: string;

      /**
       * optional repeatable client filter for charter contract reports
       */
      clientId?: Array<number>;

      /**
       * which charter date the from/to range applies to. omit for departure
       */
      dateType?: CharterContractReportDateTypes;

      /**
       * optional repeatable aircraft filter for charter contract reports (leg aircraft)
       */
      aircraftId?: Array<number>;

      /**
       * optional repeatable flight type filter for charter contract reports (contract header, exact match)
       */
      flightType?: Array<string>;

      /**
       * which ancillary charges to include. CATERING, INTERNET, LAYOVER_WAITING, FLIGHT, or ALL
       */
      chargeType: CharterContractReportChargeTypes;
    },
    context?: HttpContext
  ): Observable<GenericResponse> {
    return this.downloadCharterContractReport$Response(params, context).pipe(
      map((r: StrictHttpResponse<GenericResponse>): GenericResponse => r.body)
    );
  }

  /** Path part for operation `downloadOracleWebAdiReport()` */
  static readonly DownloadOracleWebAdiReportPath =
    '/api/v1/oracle-web-adi-reports/report';

  /**
   * to download oracle web ADI report.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `downloadOracleWebAdiReport()` instead.
   *
   * This method doesn't expect any request body.
   */
  downloadOracleWebAdiReport$Response(
    params: {
      /**
       * this adds a string search to the following fields:
       *   - from date
       */
      from?: string;

      /**
       * this adds a string search to the following fields:
       *   - to date
       */
      to?: string;

      /**
       * this adds a string search to the following fields:
       *   - client
       */
      clientId?: number;

      /**
       * this will add in oracle report
       */
      headerDate: string;

      /**
       * this will add in oracle report
       */
      headerGLDate: string;

      /**
       * This adds a filtering for reports by invoice type
       */
      invoiceType?: string;

      /**
       * This adds a filtering for reports by date type
       */
      dateType?: string;

      /**
       * This allows filtering for reports by  business type
       */
      businessType?: BusinessType;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<GenericResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      ReportService.DownloadOracleWebAdiReportPath,
      'get'
    );
    if (params) {
      rb.query('from', params.from, {});
      rb.query('to', params.to, {});
      rb.query('clientId', params.clientId, {});
      rb.query('headerDate', params.headerDate, {});
      rb.query('headerGLDate', params.headerGLDate, {});
      rb.query('invoiceType', params.invoiceType, {});
      rb.query('dateType', params.dateType, {});
      rb.query('businessType', params.businessType, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<GenericResponse>;
        })
      );
  }

  /**
   * to download oracle web ADI report.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `downloadOracleWebAdiReport$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  downloadOracleWebAdiReport(
    params: {
      /**
       * this adds a string search to the following fields:
       *   - from date
       */
      from?: string;

      /**
       * this adds a string search to the following fields:
       *   - to date
       */
      to?: string;

      /**
       * this adds a string search to the following fields:
       *   - client
       */
      clientId?: number;

      /**
       * this will add in oracle report
       */
      headerDate: string;

      /**
       * this will add in oracle report
       */
      headerGLDate: string;

      /**
       * This adds a filtering for reports by invoice type
       */
      invoiceType?: string;

      /**
       * This adds a filtering for reports by date type
       */
      dateType?: string;

      /**
       * This allows filtering for reports by  business type
       */
      businessType?: BusinessType;
    },
    context?: HttpContext
  ): Observable<GenericResponse> {
    return this.downloadOracleWebAdiReport$Response(params, context).pipe(
      map((r: StrictHttpResponse<GenericResponse>): GenericResponse => r.body)
    );
  }

  /** Path part for operation `downloadAcmsFlightReport()` */
  static readonly DownloadAcmsFlightReportPath = '/api/v1/acms-reports/report';

  /**
   * to download acms report.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `downloadAcmsFlightReport()` instead.
   *
   * This method doesn't expect any request body.
   */
  downloadAcmsFlightReport$Response(
    params?: {
      /**
       * this adds a string search to the following fields:
       *   - from date
       */
      from?: string;

      /**
       * this adds a string search to the following fields:
       *   - to date
       */
      to?: string;

      /**
       * this adds a string search to the following fields:
       *   - client
       */
      clientId?: number;

      /**
       * This adds a filtering for reports by date type
       */
      dateType?: string;

      /**
       * This enables filtering of acms flight report based on the aircraft id
       */
      aircraftId?: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<GenericResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      ReportService.DownloadAcmsFlightReportPath,
      'get'
    );
    if (params) {
      rb.query('from', params.from, {});
      rb.query('to', params.to, {});
      rb.query('clientId', params.clientId, {});
      rb.query('dateType', params.dateType, {});
      rb.query('aircraftId', params.aircraftId, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<GenericResponse>;
        })
      );
  }

  /**
   * to download acms report.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `downloadAcmsFlightReport$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  downloadAcmsFlightReport(
    params?: {
      /**
       * this adds a string search to the following fields:
       *   - from date
       */
      from?: string;

      /**
       * this adds a string search to the following fields:
       *   - to date
       */
      to?: string;

      /**
       * this adds a string search to the following fields:
       *   - client
       */
      clientId?: number;

      /**
       * This adds a filtering for reports by date type
       */
      dateType?: string;

      /**
       * This enables filtering of acms flight report based on the aircraft id
       */
      aircraftId?: number;
    },
    context?: HttpContext
  ): Observable<GenericResponse> {
    return this.downloadAcmsFlightReport$Response(params, context).pipe(
      map((r: StrictHttpResponse<GenericResponse>): GenericResponse => r.body)
    );
  }
}
